import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '@bibliocommons/base-buttons';

import './RenewButton.scss';

export default function RenewButton({ canRenew, canReturn, disabled, handleClick, isLoading }) {
  if (!canRenew) {
    return (
      <div className="cp-renew-button">
        <div className="cannot-renew-text">
          <FormattedMessage id={canReturn ? 'label_cannot_renew' : 'label_cannot_renew_or_return'} />
        </div>
      </div>
    );
  }

  return (
    <PrimaryButton
      block
      disabled={disabled}
      isLoading={isLoading}
      className="cp-renew-button"
      handleClick={handleClick}>
      <FormattedMessage id="button_renew_checkedout" />
    </PrimaryButton>
  );
}

RenewButton.propTypes = {
  disabled: PropTypes.bool,
  canRenew: PropTypes.bool,
  canReturn: PropTypes.bool,
  handleClick: PropTypes.func,
  isLoading: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/RenewButton/RenewButton.jsx